import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Dialog, Button, Box, Flex } from 'core/components';
import { TextArea, Form, Field } from 'core/form';

const fields = {
  comment: {
    name: 'comment',
    label: 'Comment',
    placeholder: 'Add optional comment...',
    defaultValue: ''
  }
};

@inject('$alerting')
@Form({ fields, options: { name: 'Clear Alert' } })
@observer
export default class ClearAlertDialog extends Component {
  static defaultProps = {
    onSubmit: () => {},
    onClose: () => {}
  };

  componentWillUnmount() {
    const { form } = this.props;
    form.reset();
  }

  handleClose = (e) => {
    const { form, onClose } = this.props;
    form.reset();
    onClose(e);
  };

  handleSubmit = (formValues) => {
    const { form, onSubmit } = this.props;

    form.reset();

    onSubmit(formValues || { comment: '' });
  };

  render() {
    const { isOpen, form } = this.props;

    return (
      <Dialog title="Clear Alert" isOpen={isOpen} onClose={this.handleClose} top={100} width={450} position="fixed">
        <Dialog.Body>
          <Box mt={2}>
            <Field name="comment" large showLabel={false}>
              <TextArea fill rows={3} autoFocus autoGrow />
            </Field>
          </Box>
        </Dialog.Body>
        <Dialog.Footer justifyContent="space-between">
          <Flex width="100%" gap={1}>
            <Button flex={1} text="Cancel" onClick={this.handleClose} />
            <Button
              flex={1}
              onClick={() => this.handleSubmit(form.getValues())}
              text="Confirm"
              intent="primary"
              disabled={!form.valid}
            />
          </Flex>
        </Dialog.Footer>
      </Dialog>
    );
  }
}
